import { Grid, Slider } from "@material-ui/core";
import React from "react";
import Dropdown from "../../../../Main/Dropdown/Dropdown";
import { SettingsType } from "../../../Write";

type Props = {
    values: SettingsType;
    setValues: (arg: SettingsType) => void;
};

const Tab2: React.FC<Props> = ({ values, setValues }) => {
    return (
        <main style={{ display: "block" }}>
            <p className="input_title" style={{ marginBottom: "10px" }}>
                PROTAGONIST NAME
            </p>
            <input
                type="text"
                value={values.protagonist}
                onChange={(e) =>
                    setValues({ ...values, protagonist: e.target.value })
                }
                style={{ marginBottom: "20px" }}
            />
            <p className="input_title" style={{ marginBottom: "10px" }}>
                OTHER NAMES FOR THE PROTAGONIST (Use comma to separate each
                name)
            </p>
            <input
                type="text"
                value={values.otherProtagonists}
                onChange={(e) =>
                    setValues({ ...values, otherProtagonists: e.target.value })
                }
                style={{ marginBottom: "20px" }}
            />
            <div className="horizontal_divider"></div>
            <div className="flex_input">
                <p className="input_title">Protagonist’S PRONOUN</p>
                <Dropdown
                    title={values.protagonistPronoun || "Select a pronoun"}
                >
                    <ul>
                        {["He", "She", "They"].map((val, idx) => (
                            <li
                                key={idx}
                                onClick={() =>
                                    setValues({
                                        ...values,
                                        protagonistPronoun: val,
                                    })
                                }
                            >
                                {val}
                            </li>
                        ))}
                    </ul>
                </Dropdown>
            </div>
            <div className="horizontal_divider"></div>
            <div className="flex_input">
                <p className="input_title">Protagonist’s ATTRIBUTES</p>
                <Dropdown
                    title={values.protagonistAttr || "Select an attribute"}
                >
                    <ul>
                        {["Teen", "Mature"].map((val, idx) => (
                            <li
                                key={idx}
                                onClick={() =>
                                    setValues({
                                        ...values,
                                        protagonistAttr: val,
                                    })
                                }
                            >
                                {val}
                            </li>
                        ))}
                    </ul>
                </Dropdown>
            </div>
            <div className="horizontal_divider"></div>
            <p className="input_title" style={{ marginBottom: "10px" }}>
                PROTAGONIST TENDS TO BE:
            </p>
            <Grid container spacing={2}>
                <Grid item>Extroverted</Grid>
                <Grid item xs>
                    <Slider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        max={10}
                        min={0}
                        value={values.protagonistScoresIntroverted}
                        onChange={(_, value) =>
                            setValues({
                                ...values,
                                protagonistScoresIntroverted: value as number,
                            })
                        }
                        color="secondary"
                    />
                </Grid>
                <Grid item>Introverted</Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item>Unlikable</Grid>
                <Grid item xs>
                    <Slider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        max={10}
                        min={0}
                        value={values.protagonistScoresLikable}
                        onChange={(_, value) =>
                            setValues({
                                ...values,
                                protagonistScoresLikable: value as number,
                            })
                        }
                        color="secondary"
                    />
                </Grid>
                <Grid item>Likable</Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item>Focused on patterns in the past</Grid>
                <Grid item xs>
                    <Slider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        max={10}
                        min={0}
                        value={values.protagonistScoresFocused}
                        onChange={(_, value) =>
                            setValues({
                                ...values,
                                protagonistScoresFocused: value as number,
                            })
                        }
                        color="secondary"
                    />
                </Grid>
                <Grid item>Focused on future possibilities</Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item>Uses Mind & Logic</Grid>
                <Grid item xs>
                    <Slider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        max={10}
                        min={0}
                        value={values.protagonistScoresEmotional}
                        onChange={(_, value) =>
                            setValues({
                                ...values,
                                protagonistScoresEmotional: value as number,
                            })
                        }
                        color="secondary"
                    />
                </Grid>
                <Grid item>Uses Heart & Emotions</Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item>Organised & Decisive Decision Making</Grid>
                <Grid item xs>
                    <Slider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        max={10}
                        min={0}
                        value={values.protagonistScoresImprovised}
                        onChange={(_, value) =>
                            setValues({
                                ...values,
                                protagonistScoresImprovised: value as number,
                            })
                        }
                        color="secondary"
                    />
                </Grid>
                <Grid item>Improvised & Open Decision Making</Grid>
            </Grid>
            <div className="horizontal_divider"></div>
            <div className="flex_input">
                <p className="input_title">
                    How will the protagonist’s personality change by the end of
                    the story?
                </p>
                <Dropdown title={values.protagonistPersonality || "Select"}>
                    <ul>
                        {["Forget", "Take Revenge"].map((val, idx) => (
                            <li
                                key={idx}
                                onClick={() =>
                                    setValues({
                                        ...values,
                                        protagonistPersonality: val,
                                    })
                                }
                            >
                                {val}
                            </li>
                        ))}
                    </ul>
                </Dropdown>
            </div>
            <div className="horizontal_divider"></div>
            <p className="input_title" style={{ marginBottom: "10px" }}>
                What is your protagonist’s ultimate goal in this story?
            </p>
            <textarea
                style={{ marginBottom: "20px" }}
                value={values.protagonistGoal}
                onChange={(e) =>
                    setValues({ ...values, protagonistGoal: e.target.value })
                }
            />
            <div className="horizontal_divider"></div>
            <div className="flex_input">
                <p className="input_title">The goal type is to</p>
                <Dropdown title={values.goalType || "Select"}>
                    <ul>
                        {["Primary", "Secondary"].map((val, idx) => (
                            <li
                                key={idx}
                                onClick={() =>
                                    setValues({ ...values, goalType: val })
                                }
                            >
                                {val}
                            </li>
                        ))}
                    </ul>
                </Dropdown>
            </div>
            <div className="horizontal_divider"></div>
        </main>
    );
};

export default Tab2;
